import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const CornerLeftUpIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="14 9 9 4 4 9"></polyline>
    <path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>
  </Icon>
);
